// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1XTAf","label":"LabeledBox_label__1vmhm"};